import Ws from 'ws';
import type { LogFn } from '../log.js';
import type { FirehoseConnectionHandle } from '../../firehose/connect-firehose.js';
import type { ReconnectQuietSlot } from './reconnect-quiet-slot.js';
import type { ReconnectOutageTracker } from './reconnect-outage-plan.js';
import {
  beginTieredSilentReconnectDisconnect,
  clearTieredReconnectChannelOnOpen,
  PREVIEW_TUNNEL_SERVICE_LABEL,
} from './tiered-channel-reconnect.js';

/** @deprecated Use {@link PREVIEW_TUNNEL_SERVICE_LABEL} */
export const PROXY_AND_LOG_SERVICE_LABEL = PREVIEW_TUNNEL_SERVICE_LABEL;

export interface FirehoseReconnectContext {
  closedByUser: boolean;
  currentWs: Ws | null;
  firehoseHandle: FirehoseConnectionHandle | null;
  firehoseQuiet: ReconnectQuietSlot;
}

export function beginFirehoseDeferredDisconnect(
  ctx: FirehoseReconnectContext,
  code: number,
  reason: string,
  log: LogFn,
): void {
  beginTieredSilentReconnectDisconnect({
    isClosedByUser: () => ctx.closedByUser,
    quiet: ctx.firehoseQuiet,
    code,
    reason,
    willReconnect: true,
    log,
    serviceLabel: PREVIEW_TUNNEL_SERVICE_LABEL,
    shouldAbortQuietWindow: () => {
      const w = ctx.currentWs;
      if (!w || w.readyState !== Ws.OPEN) return true;
      return ctx.firehoseHandle?.isConnected() ?? false;
    },
  });
}

export function clearFirehoseReconnectQuietOnOpen(
  ctx: {
    firehoseQuiet: ReconnectQuietSlot;
    firehoseOutage: ReconnectOutageTracker;
    lastFirehoseReconnectCloseMeta: { code: number; reason: string } | null;
  },
  log: LogFn,
): void {
  clearTieredReconnectChannelOnOpen({
    quiet: ctx.firehoseQuiet,
    outage: ctx.firehoseOutage,
    clearLastCloseMeta: () => {
      ctx.lastFirehoseReconnectCloseMeta = null;
    },
    log,
    restoredMessage: 'Preview tunnel restored (local HTTP proxy and dev logs).',
  });
}
